var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 20 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.356 22.066a2.3 2.3 0 0 1-1.686-.7 2.3 2.3 0 0 1-.701-1.687V4.162q-.508 0-.852-.343a1.16 1.16 0 0 1-.342-.85q0-.51.342-.852.344-.342.852-.343h4.774q0-.507.344-.85t.85-.343h4.774q.507 0 .851.342.343.345.343.851h4.775q.507 0 .85.343.343.345.343.851 0 .507-.344.851a1.15 1.15 0 0 1-.85.343v15.517q0 .985-.7 1.687-.702.7-1.687.7zm0-17.904v15.517h11.936V4.162zm2.387 11.936q0 .508.344.85.343.345.85.344.507 0 .85-.344.344-.343.343-.85V7.743q0-.508-.342-.851a1.16 1.16 0 0 0-.851-.343q-.508 0-.85.343-.344.343-.344.85zm4.775 0q0 .508.343.85.343.345.85.344.507 0 .851-.344t.343-.85V7.743q0-.508-.343-.851a1.16 1.16 0 0 0-.85-.343q-.508 0-.85.343-.344.343-.344.85z"
  })));
};
export default SvgTrash;